<div class="wlt-page">

  <!-- Header -->
  <header class="wlt-site-header">
    <div class="wlt-container">
      <img class="wlt-logo" src="assets/wealthlens-temp/Images/BCL logo_Registered R 1.png" alt="Bajaj Capital">
    </div>
  </header>

  <!-- Hero -->
  <section class="wlt-hero">
    <div class="wlt-container">
      <div class="wlt-hero-grid">
        <div class="wlt-hero-copy">
          <p class="wlt-eyebrow"><i></i> Bajaj Capital WealthLens Report</p>
          <h1>Know your portfolio,<br><em>beyond returns.</em></h1>
          <p class="wlt-lead">Get a personalised analysis of your investments in <BR><strong>under 60 seconds.</strong></p>
          <button type="button" class="wlt-gold-button" (click)="showLeadForm()">
            Get My WealthLens Report
            <span class="wlt-btn-icon">
              <img src="assets/wealthlens-temp/Images/Group_48097114.svg" alt="">
            </span>
          </button>
          <p class="wlt-privacy-line">
            <img class="wlt-lock-ico" src="assets/wealthlens-temp/Images/Vector-6.svg" alt="" width="10" height="13">
            <span class="wlt-privacy-text"><span class="wlt-privacy-part">Powered by MF Central.</span> <span class="wlt-privacy-part">Your data is never shared or sold.</span></span>
          </p>
        </div>

        <div class="wlt-report-card">
          <header>
            <strong>Your WealthLens Report</strong>
            <small>Ready in 60 sec</small>
          </header>

          <div class="wlt-score">
            <svg class="wlt-score-ring" viewBox="0 0 212 212" aria-hidden="true">
              <circle class="wlt-score-track" cx="106" cy="106" r="90"></circle>
              <circle class="wlt-score-arc" cx="106" cy="106" r="90"></circle>
            </svg>
            <div class="wlt-score-val">
              <b>7.2</b>
              <span>Out of 10</span>
            </div>
          </div>

          <h3>WealthLens Score</h3>

          <div class="wlt-report-grid">
            <span><i class="wlt-chk"></i> Risk Assessment</span>
            <span><i class="wlt-chk"></i> Portfolio Overlap</span>
            <span><i class="wlt-chk"></i> Asset Allocation</span>
            <span><i class="wlt-chk"></i> Gap Analysis</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Credibility -->
  <section class="wlt-credibility">
    <div class="wlt-container">
      <div class="wlt-credibility-grid">
        <article>
          <span class="wlt-cred-ico"><img src="assets/wealthlens-temp/Images/Frame 48097141.svg" alt=""></span>
          <b>60+ Yrs</b>
          <span>of financial expertise</span>
        </article>
        <article>
          <span class="wlt-cred-ico"><img src="assets/wealthlens-temp/Images/Group 48097140.svg" alt=""></span>
          <b>MF Central</b>
          <span>verified integration</span>
        </article>
        <article>
          <span class="wlt-cred-ico"><img src="assets/wealthlens-temp/Images/Group 48097139.svg" alt=""></span>
          <b>&lt;60 Sec</b>
          <span>to your full report</span>
        </article>
        <article>
          <span class="wlt-cred-ico"><img src="assets/wealthlens-temp/Images/Group 48097138.svg" alt=""></span>
          <b>100%</b>
          <span>secure &amp; confidential</span>
        </article>
      </div>
    </div>
  </section>

  <!-- How it works -->
  <section class="wlt-section wlt-steps">
    <div class="wlt-container">
      <p class="wlt-eyebrow wlt-centered"><i></i> How it works</p>
      <h2>Three steps. Sixty seconds.</h2>
      <p class="wlt-subtitle">No uploads, no statements to dig up - just your PAN.</p>

      <div class="wlt-step-grid">
        <article>
          <div class="wlt-step-icon">
            <img src="assets/wealthlens-temp/Images/Vector-3.svg" alt="" class="wlt-step-icon-pan-custom">
          </div>
          <h3>Enter your PAN</h3>
          <p>That's the only information<br>we need to get started.</p>
        </article>

        <div class="wlt-step-connector">
          <span class="wlt-arrow-node">
            <img src="assets/wealthlens-temp/Images/reicon_arrow-up3.svg" alt="" style="width: 45px; height: 45px;">
          </span>
        </div>

        <article>
          <div class="wlt-step-icon">
            <img src="assets/wealthlens-temp/Images/Group 48097115.svg" alt="">
          </div>
          <h3>We fetch your MF holdings</h3>
          <p>Securely, via MF Central - across every<br>fund house, not just ours.</p>
        </article>

        <div class="wlt-step-connector">
          <span class="wlt-arrow-node">
            <img src="assets/wealthlens-temp/Images/reicon_arrow-up3.svg" alt="" style="width: 45px; height: 45px;">
          </span>
        </div>

        <article>
          <div class="wlt-step-icon">
            <img src="assets/wealthlens-temp/Images/oui_nav-reports.svg" alt="">
          </div>
          <h3>Get your WealthLens Report</h3>
          <p>A complete, personalised analysis -<br>ready in under 60 seconds.</p>
        </article>
      </div>
    </div>
  </section>

  <!-- What's included -->
  <section class="wlt-section wlt-included">
    <div class="wlt-container">
      <p class="wlt-eyebrow wlt-centered"><i></i> What's included</p>
      <h2>Six things your MF statement never tells you.</h2>
      <p class="wlt-subtitle">Every WealthLens Report includes all six - no upsell, no partial version.</p>

      <div class="wlt-card-grid">
        <article>
          <i><img src="assets/wealthlens-temp/Images/Group 48097117.svg" alt=""></i>
          <h3>Portfolio Overlap Analysis</h3>
          <p>See how much duplication sits<br>across your different funds.</p>
        </article>
        <article>
          <i><img src="assets/wealthlens-temp/Images/Vector-1.svg" alt=""></i>
          <h3>WealthLens Score</h3>
          <p>One clear number for how spread<br>out your risk really is.</p>
        </article>
        <article>
          <i><img src="assets/wealthlens-temp/Images/Group.svg" alt=""></i>
          <h3>Risk Assessment</h3>
          <p>Understand the real risk you are<br>carrying, fund by fund.</p>
        </article>
        <article>
          <i><img src="assets/wealthlens-temp/Images/Vector-2.svg" alt=""></i>
          <h3>Asset Allocation Review</h3>
          <p>Equity, debt, hybrid - see the real<br>mix, not the assumed one.</p>
        </article>
        <article>
          <i><img src="assets/wealthlens-temp/Images/Group 48097124.svg" alt=""></i>
          <h3>Gap Analysis</h3>
          <p>Where your portfolio falls short of<br>your actual goals.</p>
        </article>
        <article>
          <i><img src="assets/wealthlens-temp/Images/Vector.svg" alt=""></i>
          <h3>Expert Recommendations</h3>
          <p>What a Bajaj Capital advisor<br>would suggest, based on all of it.</p>
        </article>
      </div>
    </div>
  </section>

  <!-- Security & privacy -->
  <section class="wlt-section wlt-security">
    <div class="wlt-container">
      <p class="wlt-eyebrow wlt-centered"><i></i> Security &amp; privacy</p>
      <h2>Your PAN. Your data. Your control.</h2>

      <div class="wlt-card-grid">
        <article>
          <i><img src="assets/wealthlens-temp/Images/pepicons-pencil_shield-circle.svg" alt=""></i>
          <h3>MF Central integration</h3>
          <p>Data is fetched through MF Central official, regulator-backed infrastructure - not scraped or stored elsewhere.</p>
        </article>
        <article>
          <i><img src="assets/wealthlens-temp/Images/pepicons-pencil_lock-closed-circle-1.svg" alt=""></i>
          <h3>Never sold, never shared</h3>
          <p>Your portfolio data is used only to generate your report and, if you choose, to inform an advisor conversation.</p>
        </article>
        <article>
          <i><img src="assets/wealthlens-temp/Images/pepicons-pencil_lock-closed-circle.svg" alt=""></i>
          <h3>You're always in control</h3>
          <p>No commitment, no obligation - see your report first, decide what happens next.</p>
        </article>
      </div>
    </div>
  </section>

  <!-- Final CTA -->
  <section class="wlt-final-cta">
    <div>
      <h2>Know your portfolio,<br><em>beyond returns.</em></h2>
      <p>Get a personalised analysis of your investments in <strong>under 60 seconds.</strong></p>
      <button type="button" class="wlt-gold-button" (click)="showLeadForm()">
        Get My WealthLens Report
        <span class="wlt-btn-icon">
          <img src="assets/wealthlens-temp/Images/Group_48097114.svg" alt="">
        </span>
      </button>
      <small class="wlt-privacy-line">
        <img class="wlt-lock-ico" src="assets/wealthlens-temp/Images/Vector-6.svg" alt="" width="10" height="13">
        <span class="wlt-privacy-text"><span class="wlt-privacy-part">Powered by MF Central.</span> <span class="wlt-privacy-part">Your data is never shared or sold.</span></span>
      </small>
    </div>
  </section>

  <!-- Footer -->
  <footer class="wlt-footer">
    <p>www.<strong>bajajcapital</strong>.com</p>
    <small>
      <strong>Disclaimer:</strong> Bajaj Capital Limited [(&ldquo;BCL&rdquo;) CIN:
      U67120DL1965PLC004338] having its registered office at Mezzanine Floor 97 Bajaj House, Nehru Place, New Delhi DL, 110019 is a mutual fund
      distributor (ARN 0010) registered with AMFI. Certain products and services offered by BCL may not be traded on the
      exchange. All disputes with respect to the distribution activity, would not have access to Exchange Investor Redressal
      Forum or Arbitration mechanism. In accordance with the applicable laws, BCL is allowed to render incidental advice with respect to mutual fund products only to its mutual fund distribution clients. For every other purpose, including
      distribution of non-mutual fund products, the circulated material is for informational purposes only. Further, it is not intended as investment advice or an opinion concerning securities or a public offer proving a basis for an investment
      decision. The views or expressions contained in the circulated material are not necessarily of BCL and BCL neither
      assumes any responsibility/ liability nor does guarantee its accuracy, suitability, completeness and adequacy. The
      content of the material including images, charts, graphics and pictures are protected intellectual properties and cannot
      be amended, copied, reproduced, replicated, republished, uploaded, posted, published, transmitted, displayed or
      distributed for any non-personal use without obtaining prior written permission, any non-adherence of which may attract
      appropriate legal action.
      <strong>Mutual Fund investments are subject to market risk, read all scheme-related documents carefully</strong>
      The past performance of the scheme is not indicative of future performance. Investors are advised to seek appropriate
      advice from experts before taking any investment decisions. Nothing in the circulated material is intended to construe
      an advertisement or an investment, financial advice and/or solicitation, advice to buy, sell or deal in any financial
      product.
    </small>
  </footer>

  <!-- Modal: lead form / no-data / success -->
  <div class="wlt-modal-overlay" *ngIf="isModalVisible" (click)="noDataFound ? closeNoDataPopup() : closeModal()">
    <div class="wlt-modal-card" (click)="$event.stopPropagation()">
      <button type="button" class="wlt-modal-close" (click)="noDataFound ? closeNoDataPopup() : closeModal()">&times;</button>

      <!-- No Investment Data Screen -->
      <div *ngIf="noDataFound" class="wlt-nodata-screen">
        <div class="wlt-nodata-icon">!</div>
        <h3 class="wlt-modal-heading">No current investment found</h3>
        <p class="wlt-modal-subheading">We couldn't find any mutual fund holdings linked to the details you entered. Please check your PAN and try again.</p>
        <button type="button" class="wlt-modal-submit" (click)="reloadForm()">OK</button>
      </div>

      <!-- Lead Form Screen -->
      <div *ngIf="!noDataFound && !submitted && !alreadySubmitted" class="wlt-lead-form-screen">
        <h3 class="wlt-modal-heading">Get Your WealthLens Report</h3>
        <p class="wlt-modal-subheading">Fill in your details below. Your personalised report will be ready in under 60 seconds.</p>

        <form #modalForm="ngForm" (ngSubmit)="submitModalForm(modalForm)" novalidate>
          <div class="wlt-modal-form-grid">
            <div class="wlt-form-group">
              <label for="wltFullName">Full Name<span class="wlt-required">*</span></label>
              <input
                id="wltFullName"
                type="text"
                name="wltFullName"
                [(ngModel)]="name"
                required
                minlength="3"
                maxlength="70"
                pattern="^[A-Za-z ]+$"
                #wltFullName="ngModel"
                placeholder="Enter your name"
                autocomplete="name"
                (keypress)="onlyLetters($event)"
                (paste)="onPasteName($event)">
              <div class="wlt-field-error" *ngIf="wltFullName.invalid && (wltFullName.touched || formSubmitted)">
                <span *ngIf="wltFullName.errors?.['required']">Full name is required.</span>
                <span *ngIf="wltFullName.errors?.['minlength']">Enter at least 3 characters.</span>
                <span *ngIf="wltFullName.errors?.['pattern']">Only letters and spaces are allowed.</span>
              </div>
            </div>

            <div class="wlt-form-group">
              <label for="wltPan">PAN<span class="wlt-required">*</span></label>
              <input
                id="wltPan"
                type="text"
                name="wltPan"
                [(ngModel)]="pan"
                required
                minlength="10"
                maxlength="10"
                pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                #wltPanField="ngModel"
                placeholder="Enter PAN"
                autocomplete="off"
                style="text-transform: uppercase"
                (input)="convertPanToUppercase()">
              <div class="wlt-field-error" *ngIf="wltPanField.invalid && (wltPanField.touched || formSubmitted)">
                <span *ngIf="wltPanField.errors?.['required']">PAN is required.</span>
                <span *ngIf="wltPanField.errors?.['minlength'] || wltPanField.errors?.['pattern']">Enter a valid PAN, for example ABCDE1234F.</span>
              </div>
            </div>

            <div class="wlt-form-group">
              <label for="wltMobile">Mobile Number<span class="wlt-required">*</span></label>
              <input
                id="wltMobile"
                type="tel"
                name="wltMobile"
                [(ngModel)]="mobile"
                required
                minlength="10"
                maxlength="10"
                pattern="^[6-9][0-9]{9}$"
                #wltMobileField="ngModel"
                placeholder="Enter 10-digit mobile"
                autocomplete="tel"
                inputmode="numeric"
                (keypress)="onlyNumbers($event)"
                (paste)="onPasteNumber($event)">
              <div class="wlt-field-error" *ngIf="wltMobileField.invalid && (wltMobileField.touched || formSubmitted)">
                <span *ngIf="wltMobileField.errors?.['required']">Mobile number is required.</span>
                <span *ngIf="wltMobileField.errors?.['minlength'] || wltMobileField.errors?.['pattern']">Enter a valid 10-digit mobile number starting with 6-9.</span>
              </div>
            </div>

            <div class="wlt-form-group">
              <label for="wltEmail">Email Address<span class="wlt-required">*</span></label>
              <input
                id="wltEmail"
                type="email"
                name="wltEmail"
                [(ngModel)]="email"
                required
                email
                maxlength="80"
                #wltEmailField="ngModel"
                placeholder="Enter your email"
                autocomplete="email"
                (keydown.space)="$event.preventDefault()">
              <div class="wlt-field-error" *ngIf="wltEmailField.invalid && (wltEmailField.touched || formSubmitted)">
                <span *ngIf="wltEmailField.errors?.['required']">Email address is required.</span>
                <span *ngIf="wltEmailField.errors?.['email']">Enter a valid email address.</span>
              </div>
            </div>

            <div class="wlt-form-group">
              <label for="wltReportType">Risk Profile<span class="wlt-required">*</span></label>
              <select
                id="wltReportType"
                name="wltReportType"
                [(ngModel)]="reportType"
                required
                #wltReportTypeField="ngModel">
                <option value="" disabled>Select risk profile</option>
                <option *ngFor="let opt of reportTypeOptions" [value]="opt.value">{{ opt.label }}</option>
              </select>
              <div class="wlt-field-error" *ngIf="wltReportTypeField.invalid && (wltReportTypeField.touched || formSubmitted)">
                <span *ngIf="wltReportTypeField.errors?.['required']">Risk profile is required.</span>
              </div>
            </div>
          </div>

          <p class="wlt-form-error" *ngIf="errorMessage">{{ errorMessage }}</p>

          <button type="submit" class="wlt-modal-submit" [disabled]="modalForm.invalid || loadingSm">
            {{ loadingSm ? 'Please wait...' : 'Generate WealthLens Report' }}
          </button>
        </form>
      </div>

      <!-- Success / Already-submitted Screen -->
      <div *ngIf="!noDataFound && (submitted || alreadySubmitted)" class="wlt-success-screen">
        <div class="wlt-success-icon">&#10004;</div>
        <h3 class="wlt-modal-heading">{{ alreadySubmitted ? 'Already Submitted' : 'Thank You!' }}</h3>
        <p class="wlt-modal-subheading">{{ successMessage || 'Your WealthLens Report is being generated. Our advisor will connect shortly.' }}</p>
        <button type="button" class="wlt-modal-submit" (click)="closeModal()">Done</button>
      </div>

    </div>
  </div>

</div>
